import React, { useState } from 'react';
import './Home.css';
import AskQuestion from '../components/questionbox';
import PostCard from '../components/PostCard';
import WelcomeHero from '../components/WelcomeHero';

function Home({ searchQuery, toggleSavePost, savedPosts, posts = [], addPost, user }) {
    const [sortBy, setSortBy] = useState('popular'); // 'popular' | 'latest'

    // Türkçe aksanları/aksan işaretlerini kaldırıp küçük harfe çevirir —
    // "başvuru" yazılınca "basvuru" da, "altyapı" yazılınca "altyapi" da eşleşsin diye.
    const normalize = (str) =>
        (str || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ı/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/ş/g, 's')
            .replace(/ö/g, 'o')
            .replace(/ç/g, 'c');

    // Net oy hesabı — backend upvote_count/downvote_count döndürüyor, tek bir
    // "votes" alanı yok (PostCard'daki mantıkla aynı).
    const getNetVotes = (post) =>
        (post.upvote_count !== undefined || post.downvote_count !== undefined)
            ? ((post.upvote_count || 0) - (post.downvote_count || 0))
            : (post.votes ?? 0);

    // Arama kelimesine ve veritabanı alanlarına göre filtreleme
    const filteredPosts = posts.filter((post) => {
        const query = normalize(searchQuery ? searchQuery.trim() : "");
        if (!query) return true;

        const titleMatch = post.title ? normalize(post.title).includes(query) : false;
        const descSource = post.body || post.description || post.content || '';
        const descMatch = normalize(descSource).includes(query);
        const tagMatch = post.tags && Array.isArray(post.tags)
            ? post.tags.some(tag => normalize(tag).includes(query))
            : false;

        return titleMatch || descMatch || tagMatch;
    });

    // Sabitlenmiş gönderiler (is_pinned) üstte, ardından sıralama tercihine göre dizilim
    const sortedPosts = [...filteredPosts].sort((a, b) => {
        if (a.is_pinned && !b.is_pinned) return -1;
        if (!a.is_pinned && b.is_pinned) return 1;

        if (sortBy === 'latest') {
            return new Date(b.createdAt || b.created_at || 0) - new Date(a.createdAt || a.created_at || 0);
        }
        // 'popular' sıralaması
        return getNetVotes(b) - getNetVotes(a);
    });

    return (
        <div className="Home">
            <WelcomeHero user={user} />

            {/* Soru sorma kutusu */}
            <AskQuestion onAddPost={addPost} user={user} />

            <hr className="section-divider" />

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 className="section-title" style={{ margin: 0 }}>Sorular & Tartışmalar</h2>
                <div style={{ display: 'flex', gap: '8px', paddingRight: '10px' }}>
                    <button
                        onClick={() => setSortBy('popular')}
                        style={{
                            padding: '6px 14px',
                            borderRadius: '6px',
                            border: sortBy === 'popular' ? 'none' : '1px solid var(--line-strong)',
                            background: sortBy === 'popular' ? 'var(--accent)' : '#fff',
                            color: sortBy === 'popular' ? '#fff' : 'var(--ink)',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: '13px'
                        }}
                    >
                        Popüler
                    </button>
                    <button
                        onClick={() => setSortBy('latest')}
                        style={{
                            padding: '6px 14px',
                            borderRadius: '6px',
                            border: sortBy === 'latest' ? 'none' : '1px solid var(--line-strong)',
                            background: sortBy === 'latest' ? 'var(--accent)' : '#fff',
                            color: sortBy === 'latest' ? '#fff' : 'var(--ink)',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: '13px'
                        }}
                    >
                        En Yeni
                    </button>
                </div>
            </div>

            {sortedPosts.length > 0 ? (
                sortedPosts.map((post) => (
                    <PostCard
                        key={post.id}
                        post={post}
                        toggleSavePost={toggleSavePost}
                        isSaved={savedPosts.some((p) => p.id === post.id)}
                    />
                ))
            ) : (
                <p style={{ padding: '20px', color: 'var(--muted)' }}>Aradığınız kriterlere uygun soru bulunamadı.</p>
            )}
        </div>
    );
}

export default Home;